import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import MuiPlayArrow from '@mui/icons-material/PlayArrow';
import Box from '@mui/material/Box';

import { black16 } from '~/styles';

export const PlayArrow = styled(MuiPlayArrow)`
  font-size: 40px;
  color: white;
` as React.FC<PropsWithChildren<React.ComponentProps<typeof MuiPlayArrow>>>;

export const MediaPlayIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  height: 58px;
  width: 58px;
  border-radius: 50%;
  border: 1px solid white;
`;

export const CoursePreviewCardWrapper = styled(Box)`
  box-shadow: 0 4px 8px 0 ${black16};
  cursor: pointer;
`;

export const CourseImageOverlay = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
`;
